// // import Leaves from './Leaves';
// // import SalaryDetails from './SalaryDetails';
// // import { useNavigate } from 'react-router-dom';
// // import UserDashboardTest from '../Test/UserDashboard';
// import React, { useContext, useEffect, useState } from 'react';
// import RequestsInProgress from './RequestsInProgress';
// import './UserDashboardStyle.css';
// import UserProfile from './UserProfile/UserProfile';
// import { AppSettings } from '@config/app-settings';
// import UserNotifications from './NotificationsList';

// const UserDashboard = () => {
//   const context = React.useContext(AppSettings);

//   React.useEffect(() => {
//     sessionStorage.setItem('CurrentSystem', 'USER');
//     context.setsysCode('USER');
//     context.setAppSidebarNone(true);
//     return function cleanUp() {
//       context.setAppSidebarNone(false);
//     };

//     // eslint-disable-next-line
//   }, []);

//   const [notifications, setNotifications] = useState<any[]>([]);
//   const [unreadCount, setUnreadCount] = useState(0);

//   // محاكاة بيانات الإشعارات
//   const mockNotifications = [
//     { id: 1, title: 'طلب جديد', message: 'تم إنشاء طلبك رقم #1234', time: 'منذ 5 دقائق', read: false, type: 'info' },
//     {
//       id: 2,
//       title: 'تم التحديث',
//       message: 'تم تحديث حالة طلبك رقم #5678',
//       time: 'منذ ساعة',
//       read: false,
//       type: 'success'
//     },
//     { id: 3, title: 'تنبيه', message: 'يوجد مشكلة في ملفك الشخصي', time: 'منذ يوم', read: true, type: 'warning' },
//     { id: 4, title: 'ترحيب', message: 'مرحباً بك في نظامنا!', time: 'منذ أسبوع', read: true, type: 'info' }
//   ];

//   useEffect(() => {
//     sessionStorage.setItem('CurrentSystem', 'USER');
//     context.setsysCode('USER');
//     context.setAppSidebarNone(true);

//     // تحميل الإشعارات (في تطبيق حقيقي، سيتم جلبها من API)
//     setNotifications(mockNotifications);
//     setUnreadCount(mockNotifications.filter(n => !n.read).length);

//     return function cleanUp() {
//       context.setAppSidebarNone(false);
//     };
//     // eslint-disable-next-line
//   }, []);

//   const markAsRead = id => {
//     const updatedNotifications = notifications.map(notification =>
//       notification.id === id ? { ...notification, read: true } : notification
//     );
//     setNotifications(updatedNotifications);
//     setUnreadCount(updatedNotifications.filter(n => !n.read).length);
//   };

//   const markAllAsRead = () => {
//     const updatedNotifications = notifications.map(notification => ({
//       ...notification,
//       read: true
//     }));
//     setNotifications(updatedNotifications);
//     setUnreadCount(0);
//   };

//   const getNotificationIcon = type => {
//     switch (type) {
//       case 'info':
//         return 'fas fa-info-circle text-info';
//       case 'success':
//         return 'fas fa-check-circle text-success';
//       case 'warning':
//         return 'fas fa-exclamation-triangle text-warning';
//       case 'danger':
//         return 'fas fa-exclamation-circle text-danger';
//       default:
//         return 'fas fa-bell text-info';
//     }
//   };

//   const NotificationItem = ({ notification }) => (
//     <div className={`d-flex align-items-center p-3 border-bottom ${!notification.read ? 'bg-light' : ''}`}>
//       <div className='mr-3'>
//         <i className={`${getNotificationIcon(notification.type)} fa-lg`}></i>
//       </div>
//       <div className='flex-grow-1'>
//         <h6 className='mb-1'>{notification.title}</h6>
//         <p className='mb-1 small text-muted'>{notification.message}</p>
//         <small className='text-muted'>{notification.time}</small>
//       </div>
//       {!notification.read && (
//         <button
//           className='btn btn-sm btn-outline-primary'
//           onClick={() => markAsRead(notification.id)}
//           title='وضع علامة مقروء'
//         >
//           <i className='fas fa-check'></i>
//         </button>
//       )}
//     </div>
//   );

//   return (
//     <>
//       <div className='row d-flex align-items-stretch'>
//         <div className='col-md-7 mb-4'>
//           <UserProfile />
//         </div>
//         <div className='col-md-5 mb-4'>
//           <RequestsInProgress />
//         </div>
//         <div className='col-md-5 mb-4'>
//           <UserNotifications />
//         </div>
//       </div>
//     </>
//   );
// };

// // );

// export default UserDashboard;


import React, { useContext, useEffect, useState } from 'react';
import RequestsInProgress from './RequestsInProgress';
import './UserDashboardStyle.css';
import UserProfile from './UserProfile/UserProfile';
import { AppSettings } from '@config/app-settings';
import UserNotifications from './NotificationsList';

const UserDashboard: React.FC = () => {
  const context = useContext(AppSettings);

  const [notifications, setNotifications] = useState<any[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // بيانات وهمية للإشعارات (استبدل لاحقًا بجلب من API)
  const mockNotifications = [
    { id: 1, title: 'طلب جديد', message: 'تم إنشاء طلبك رقم #1234', time: 'منذ 5 دقائق', read: false, type: 'info' },
    { id: 2, title: 'تم التحديث', message: 'تم تحديث حالة طلبك رقم #5678', time: 'منذ ساعة', read: false, type: 'success' },
    { id: 3, title: 'تنبيه', message: 'يوجد مشكلة في ملفك الشخصي', time: 'منذ يوم', read: true, type: 'warning' },
    { id: 4, title: 'ترحيب', message: 'مرحباً بك في نظامنا!', time: 'منذ أسبوع', read: true, type: 'info' }
  ];

  useEffect(() => {
    // لا حاجة لتخزين محلي أو ضبط sysCode هنا؛ سيتم اشتقاقه من URL عبر useModuleRoutingSync
    context.setAppSidebarNone(true);

    // تحميل الإشعارات (استبدل لاحقًا بمناداة API)
    setNotifications(mockNotifications);
    setUnreadCount(mockNotifications.filter(n => !n.read).length);

    return () => {
      context.setAppSidebarNone(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const markAsRead = (id: number) => {
    const updated = notifications.map(n => (n.id === id ? { ...n, read: true } : n));
    setNotifications(updated);
    setUnreadCount(updated.filter(n => !n.read).length);
  };

  const markAllAsRead = () => {
    const updated = notifications.map(n => ({ ...n, read: true }));
    setNotifications(updated);
    setUnreadCount(0);
  };

  const getNotificationIcon = (type: string) => {
    switch (type) {
      case 'info':
        return 'fas fa-info-circle text-info';
      case 'success':
        return 'fas fa-check-circle text-success';
      case 'warning':
        return 'fas fa-exclamation-triangle text-warning';
      case 'danger':
        return 'fas fa-exclamation-circle text-danger';
      default:
        return 'fas fa-bell text-info';
    }
  };

  // مكوّن عنصر إشعار (غير مستخدم هنا لأن لديك UserNotifications منفصل)
  // اتركه للرجوع أو احذفه إن لم يكن مطلوبًا
  const NotificationItem = ({ notification }: { notification: any }) => (
    <div className={`d-flex align-items-center p-3 border-bottom ${!notification.read ? 'bg-light' : ''}`}>
      <div className='me-3'>
        <i className={`${getNotificationIcon(notification.type)} fa-lg`}></i>
      </div>
      <div className='flex-grow-1'>
        <h6 className='mb-1'>{notification.title}</h6>
        <p className='mb-1 small text-muted'>{notification.message}</p>
        <small className='text-muted'>{notification.time}</small>
      </div>
      {!notification.read && (
        <button
          className='btn btn-sm btn-outline-primary'
          onClick={() => markAsRead(notification.id)}
          title='وضع علامة مقروء'
        >
          <i className='fas fa-check'></i>
        </button>
      )}
    </div>
  );

  return (
    <>
      <div className='row d-flex align-items-stretch'>
        <div className='col-md-7 mb-4'>
          <UserProfile />
        </div>
        <div className='col-md-5 mb-4'>
          <RequestsInProgress />
        </div>
        <div className='col-md-5 mb-4'>
          <UserNotifications />
        </div>
      </div>
    </>
  );
};

export default UserDashboard;
